import { useEffect } from 'react';
/**
 * На тач устройствах клик в любую соседнюю область не закрывает тултип
 */
export function useTooltipFix({ state, popoverRef, targetRef, }) {
    useEffect(() => {
        function clickOutside(e) {
            var _a, _b;
            if (e.target === (popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) || ((_a = popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
                return;
            }
            if (e.target === targetRef.current || ((_b = targetRef.current) === null || _b === void 0 ? void 0 : _b.contains(e.target))) {
                return;
            }
            if (state.isOpen) {
                state.close(true);
            }
        }
        document.addEventListener('touchend', clickOutside, true);
        return () => {
            document.removeEventListener('touchend', clickOutside, true);
        };
    }, [state]);
}
